import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { getSmartImage } from '../../../helpers/helpers';

// Avatar for the user and brand lookups: CloudFront-normalised like the rest of the admin, with an
// initial as the fallback when there is no image or the image fails to load.
const EntityAvatar = ({ image, name, square, className }) => {
  const [failed, setFailed] = useState(false);
  const src = getSmartImage(image);
  if (!src || failed) return <div className={cn(className, 'placeholder', { square })}>{(name || '?')[0]}</div>;
  return <img src={src} alt='' className={cn(className, { square })} onError={() => setFailed(true)} />;
};

EntityAvatar.propTypes = {
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  name: PropTypes.string,
  square: PropTypes.bool,
  className: PropTypes.string.isRequired
};

export default EntityAvatar;
